// Author YuJiaBei
// Date 2020-10-10 14:00:25

class SithMesMstShiftTime {
constructor({
        id = null,
        name = '',
        startTime = '',
        endTime = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.startTime = startTime;
    this.endTime = endTime;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstShiftTime();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstShiftTime.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'startTime',
        label: 'label.sith.mst.sithMesMstShiftTime.grid.startTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'endTime',
        label: 'label.sith.mst.sithMesMstShiftTime.grid.endTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstShiftTime.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.mst.sithMesMstShiftTime.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstShiftTime.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'startTime',
        label: 'label.sith.mst.sithMesMstShiftTime.entity.startTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
            ,required: true
                }
        },
        {
        key: 'endTime',
        label: 'label.sith.mst.sithMesMstShiftTime.entity.endTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstShiftTime.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstShiftTime, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
